/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function packingTpes(instance) {
	return {
		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (id, config = {}) => {
			return instance.get(`packing_type/${id}`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`packing_type/page${params}`, config)
		},

		/**
		 * @param {number} id
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (id, body, config = {}) => {
			return instance.put(`packing_type/${id}`, body, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (id, config = {}) => {
			return instance.delete(`packing_type/${id}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('packing_type', body, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllNotPaged: (config = {}) => {
			return instance.get(`packing_type`, config)
		}
	}
}
